<div class="container px-0">
	<mat-card [ngClass]="theme">
		<ng-content></ng-content>
	</mat-card>
</div>
